import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import {
  Container, Header, Icon, Menu, Segment
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import roleControl from '../../auth/roleControl';
import authorize from '../../auth/authorize';
import NominaCooperativasView from './NominaCooperativasView';
import BusquedaCooperativasView from './BusquedaCooperativasView';

const RCMenuItem = roleControl(['sysadmin', 'supervisor'])(Menu.Item);
const RCMenuItemCommon = roleControl(['sysadmin', 'supervisor', 'operator'])(Menu.Item);
const RCNominaCooperativasView = roleControl(['sysadmin', 'supervisor'])(NominaCooperativasView);

class CooperativasView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Header as="h2">
          <Icon name="users" />
          <Header.Content>
            Cooperativas
            <Header.Subheader>
              Administrar Cooperativas
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Menu attached="top" tabular>
          <RCMenuItem
            as={Link} to="/cooperativas/nomina"
            active={!!window.location.pathname.match(new RegExp(`^/cooperativas/nomina/?$`))}
            name="nomina" />
          <RCMenuItemCommon
            as={Link} to="/cooperativas/busqueda"
            active={!!window.location.pathname.match(new RegExp(`^/cooperativas/busqueda/?$`))}
            name="detalle" />
        </Menu>
        <Route path={`${this.props.match.url}/nomina`} render={() => {
          return (
            <Segment attached="bottom">
              <RCNominaCooperativasView />
            </Segment>
          );
        }} />
        <Route path={`${this.props.match.url}/busqueda`} render={() => {
          return (
            <Segment attached="bottom">
              <BusquedaCooperativasView />
            </Segment>
          );
        }} />
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    CooperativasView.mapStateToProps,
    CooperativasView.mapDispatchToProps
  )(CooperativasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CooperativasView.js